import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useStates } from '@tiger/hooks';
import { Helmet } from 'react-helmet';
import Loading from 'components/Loading';
import ErrorBox from 'components/ErrorBox';

import store from '../../../store';
import EmptyHelp from '../../../components/EmptyHelp';

const Content: React.FC<
    { data: any } & RouteComponentProps<{
        main: string;
        sub?: string;
    }>
> = props => {
    if (!props.data || !(props.data as any).content) {
        return <EmptyHelp>Sorry, this content isn't available right now</EmptyHelp>;
    }

    return (
        <div className="a-flyRightIn">
            <Helmet>
                <title>{props.data.title} - Help</title>
            </Helmet>
            <div dangerouslySetInnerHTML={{ __html: (props.data as any).content }} />
        </div>
    );
};

export default function HelpContent(props) {
    const { sub } = props.match.params;
    const [state, setState] = useStates({
        isMount: false,
        loading: false,
        data: props.data,
        error: null as any
    });

    const getData = async () => {
        setState({
            loading: true
        });

        try {
            const data = await store.getListDetail(sub);

            setState({
                data
            });
        } catch (error) {
            setState({
                error
            });
        }

        setState({
            loading: false
        });
    };

    useEffect(() => {
        if (!props.data || state.isMount) {
            getData();
        }

        setState({
            isMount: true
        });
        // eslint-disable-next-line
    }, [sub]);

    function render() {
        if (state.loading) {
            return <Loading tip="loading..." />;
        }

        if (state.error) {
            return <ErrorBox error={state.error} onClick={getData} />;
        }

        return <Content {...props} data={state.data} />;
    }

    return <div className="content-root">{render()}</div>;
}
